import {Module} from '@q9elements/ui-kit/common';
import {find, get, map} from 'lodash';

export enum ROUTES {
  CORPORATE = 'enterprises',
  SPACES = 'spaces',
  DOMAINS = 'domains',
  USERS = 'users',
  NOT_FOUND = '404'
}

export const MODULES: {[key: string]: Module} = {
  [ROUTES.CORPORATE]: {
    title: 'ENTERPRISE.CORP_MANAGEMENT_TITLE',
    path: ROUTES.CORPORATE,
    icon: 'icon-corporate',
    queryParams: {ref: 'active'},
    tabs: [
      {label: 'ENTERPRISE.ACTIVE_TAB', queryParams: {ref: 'active'}},
      {label: 'ENTERPRISE.SUSPENDED_TAB', queryParams: {ref: 'suspended'}}
    ]
  },
  [ROUTES.SPACES]: {
    title: 'TEAMS.TEAMS_TITLE',
    path: ROUTES.SPACES,
    icon: 'icon-logo'
  },
  [ROUTES.USERS]: {
    title: 'USERS.USERS_TITLE',
    path: ROUTES.USERS,
    icon: 'icon-user'
  },
  [ROUTES.DOMAINS]: {
    title: 'DOMAINS.DOMAINS_TITLE',
    path: ROUTES.DOMAINS,
    icon: 'icon-domains',
    queryParams: {ref: 'active'},
    tabs: [
      {label: 'DOMAINS.ACTIVE_TAB', queryParams: {ref: 'active'}},
      {label: 'DOMAINS.BLACKLIST_TAB', queryParams: {ref: 'blocked'}}
    ]
  }
};

export function getModuleLinks() {
  return Object.keys(MODULES);
}

export function getModuleConfigs() {
  return Object.keys(MODULES).map(link => MODULES[link]);
}

export function getModuleQueryParams(path: string) {
  const modules = getModuleConfigs();
  const module = find(modules, {path});

  return map(module?.tabs, tab => get(tab, 'queryParams.ref'));
}
